export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00412.1ea0fba9.png";